import { getResolvedRefDeep as e } from "@scalar/workspace-store/helpers/get-resolved-ref-deep";
import { getResolvedRef as t, mergeSiblingReferences as n } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { buildRequestBody as r, coerceLeafValueToSchemaType as i, getExample as a, getExampleFromBody as o, getExampleFromSchema as s, needsMultipartEncoding as c, resolveLeafSchema as l, serializeFormPropertyWithEncoding as u, serializeMultipartArray as d, serializeMultipartBody as f } from "@scalar/workspace-store/request-example";
import { isXmlMediaType as p } from "@scalar/helpers/http/is-xml-media-type";
import { getExampleValue as m, getExplicitExampleText as h } from "@scalar/workspace-store/helpers/get-example-value";
import { serializeStreamExample as g } from "@scalar/workspace-store/helpers/serialize-stream-example";
import { unpackProxyObject as _ } from "@scalar/workspace-store/helpers/unpack-proxy";
//#region src/code-example/helpers/operation-to-har/process-body.ts
var v = (e, t, n) => ({
	name: e,
	value: `@${t}`,
	fileName: t,
	...n ? { contentType: n } : {}
}), y = (e) => !!e && "type" in e && e.type === "string" && "format" in e && e.format === "binary", b = (e, t) => typeof e == "string" && e.startsWith("@") && y(t) ? e.slice(1) : void 0, x = (e, t, n, r = !1, a) => {
	let o = [], s = Array.isArray(e) ? e.filter((e) => !e.isDisabled).map((e) => [String(e.name), e.value]) : Object.entries(e);
	for (let [c, f] of s) {
		if (f == null) continue;
		let s = n ? void 0 : t?.[c];
		if (r && !n) {
			let t = Array.isArray(e) ? i(f, l(a, [c])) : f, n = d(c, Array.isArray(t) ? t : f, s);
			if (n) {
				for (let e of n) {
					if (e.value instanceof File) {
						o.push(v(e.key, e.value.name, e.contentType ?? e.value.type));
						continue;
					}
					o.push({
						name: e.key,
						value: e.value,
						...e.contentType ? { contentType: e.contentType } : {}
					});
				}
				continue;
			}
		}
		let p = s && (s.style !== void 0 || s.explode !== void 0 || s.allowReserved !== void 0), m = p || !r ? void 0 : s?.contentType, h = r && !n ? b(f, l(a, [c])) : void 0, g = n ? null : u(c, f, s);
		if (g) for (let e of g) o.push({
			name: e.key,
			value: e.value
		});
		else if (f instanceof File) {
			let e = _(f);
			o.push(v(c, e.name, m ?? (r ? e.type : void 0)));
		} else if (h !== void 0) o.push(v(c, h, m));
		else if (m && typeof f == "object") o.push({
			name: c,
			value: JSON.stringify(_(f)),
			contentType: m
		});
		else if (r && !n && !p && typeof f == "object" && !Array.isArray(f)) o.push({
			name: c,
			value: JSON.stringify(_(f)),
			contentType: "application/json"
		});
		else if (Array.isArray(f)) for (let e of f) if (e instanceof File) {
			let t = _(e);
			o.push(v(c, t.name, r ? t.type : void 0));
		} else o.push({
			name: c,
			value: String(e)
		});
		else if (typeof f == "object") {
			let e = x(f, void 0, c);
			for (let t of e) o.push({
				name: `${c}.${t.name}`,
				value: t.value
			});
		} else o.push({
			name: c,
			value: String(f),
			...m ? { contentType: m } : {}
		});
	}
	return o;
}, S = ({ requestBody: i, contentType: l, example: u, openapiVersion: d, requestBodyCompositionSelection: v }) => {
	let y = l || Object.keys(i.content)[0] || "", b = y === "other" ? "" : y, S = (e) => `@${_(e).name || "filename"}`, C = i.content[y]?.encoding, w = i.content[y];
	if (w && c(y, w)) {
		let e = u ?? Object.keys(w.examples ?? {})[0] ?? "default", t = r({
			...i,
			"x-scalar-selected-content-type": { [e]: y }
		}, e, v);
		if (t?.mode === "multipart") {
			let e = f(t.value, t.contentType);
			return {
				mimeType: e.contentType,
				text: e.chunks.map((e) => e instanceof File ? S(e) : e instanceof Blob ? "BINARY" : String(e)).join("")
			};
		}
	}
	let T = y === "multipart/form-data" || y === "application/x-www-form-urlencoded";
	if (p(y)) {
		let e = o(i, y, u ?? "", v, d);
		return e ? {
			mimeType: b,
			text: e.value
		} : void 0;
	}
	let E = m(a(i, u, l)), D = h(E, y);
	if (D !== void 0) return {
		mimeType: b,
		text: D
	};
	let O = E?.value;
	if (O !== void 0) {
		let e = typeof O == "object" && O ? _(O) : O;
		return T && typeof e == "object" && e ? {
			mimeType: b,
			params: x(e, C, void 0, y === "multipart/form-data", t(i.content[y]?.schema, n))
		} : e instanceof File ? {
			mimeType: b,
			text: S(e)
		} : {
			mimeType: b,
			text: typeof e == "string" ? e : g(e, y, !1) ?? JSON.stringify(e)
		};
	}
	let k = i.content[y], A = t(k?.schema ?? k?.itemSchema);
	if (A !== void 0) {
		let t = e(A), n = s(t, {
			compositionSelection: v,
			mode: "write",
			binaryAsFile: y === "multipart/form-data"
		}, { schemaPath: ["requestBody"] });
		if (n !== void 0) return T && typeof n == "object" && n ? {
			mimeType: b,
			params: x(n, C, void 0, y === "multipart/form-data", t)
		} : {
			mimeType: b,
			text: g(n, y, k?.schema === void 0) ?? (typeof n == "string" ? n : JSON.stringify(n))
		};
	}
};
//#endregion
export { S as processBody };

//# sourceMappingURL=process-body.js.map